import styled from 'styled-components';

export const PaginationArea = styled.div`
  width: 100%;
  margin: 10px 0;
  display: flex;
  justify-content: space-between;
  color: white;
  font-size: 13px;
  font-weight: normal !important;

  label {
    font-weight: ${(props) => props.theme.font.weight.ultralight};
  }

  select{
    margin: 5px;
    background-color: gray;
    color: white;
  }

`;

export const RowsDropdown = styled.div`
  width: 275px;
  display: flex;
  align-items: center;
  padding: 0 15px;
`;

export const PaginationButtons = styled.div`
  padding: 0 15px;
  width: 120px;
  
  .Pagination {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 100%;

    > div.disabled {
      color: gray;
      cursor: not-allowed;
    }
  }
`;

export const RowsPerPage = styled.div`
  display: inline-table !important;
  margin: 0 4px;

  select {
    margin: 0px 4px 0px 4px;
    width: 42px;
  }
`;
